import { LogService } from "../../../shared/services/log.service";
import { Validator } from "../../../shared/services/validator";
import { CTRL_NAME_EXTRACTOR } from "../ctrl.name.extractor";

export class CTRL_637 implements Validator {

    public static id = 'CTRL_637';
    private message = 'error.ctr_637';


    public LOG: LogService = new LogService(CTRL_637);

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_637.id + '_');

        if (rgs.length > 0) {
            for (var rg of rgs) {
                const ctrl = form.controls[rg];

                const adrCpNameWithStepId = map.get(ctrl.value.rgCtrls.adrCp);
                const adrCp_eNameWithStepId = map.get(ctrl.value.rgCtrls.adrCp_e);
                const adrPaysNameWithStepId = map.get(ctrl.value.rgCtrls.adrPays);
                const adrVilleNameWithStepId = map.get(ctrl.value.rgCtrls.adrVille);
                const adrVoieNomvoieNameWithStepId = map.get(ctrl.value.rgCtrls.adrVoieNomvoie);
                const adrVoieNumNameWithStepId = map.get(ctrl.value.rgCtrls.adrVoieNum);
                const adrVoieTypevoieNameWithStepId = map.get(ctrl.value.rgCtrls.adrVoieTypevoie);
                const adrVoie_eNomvoieNameWithStepId = map.get(ctrl.value.rgCtrls.adrVoie_eNomvoie);
                const adrVoie_eNumNameWithStepId = map.get(ctrl.value.rgCtrls.adrVoie_eNum);
                const adrVoie_eTypevoieNameWithStepId = map.get(ctrl.value.rgCtrls.adrVoie_eTypevoie);
                const codeIdentificationNationalNameWithStepId = map.get(ctrl.value.rgCtrls.codeIdentificationNational);
                const coordFaxNameWithStepId = map.get(ctrl.value.rgCtrls.coordFax);
                const coordMelNameWithStepId = map.get(ctrl.value.rgCtrls.coordMel);
                const coordTelNameWithStepId = map.get(ctrl.value.rgCtrls.coordTel);
                const coordUrlNameWithStepId = map.get(ctrl.value.rgCtrls.coordUrl);
                const personneMoraleNameWithStepId = map.get(ctrl.value.rgCtrls.personneMorale);

                const adrCpCtrl = form.controls[adrCpNameWithStepId];
                const adrCp_eCtrl = form.controls[adrCp_eNameWithStepId];
                const adrPaysCtrl = form.controls[adrPaysNameWithStepId];
                const adrVilleCtrl = form.controls[adrVilleNameWithStepId];
                const adrVoieNomvoieCtrl = form.controls[adrVoieNomvoieNameWithStepId];
                const adrVoieNumCtrl = form.controls[adrVoieNumNameWithStepId];
                const adrVoieTypevoieCtrl = form.controls[adrVoieTypevoieNameWithStepId];
                const adrVoie_eNomvoieCtrl = form.controls[adrVoie_eNomvoieNameWithStepId];
                const adrVoie_eNumCtrl = form.controls[adrVoie_eNumNameWithStepId];
                const adrVoie_eTypevoieCtrl = form.controls[adrVoie_eTypevoieNameWithStepId];
                const codeIdentificationNationalCtrl = form.controls[codeIdentificationNationalNameWithStepId];
                const coordFaxCtrl = form.controls[coordFaxNameWithStepId];
                const coordMelCtrl = form.controls[coordMelNameWithStepId];
                const coordTelCtrl = form.controls[coordTelNameWithStepId];
                const coordUrlCtrl = form.controls[coordUrlNameWithStepId];
                const personneMoraleCtrl = form.controls[personneMoraleNameWithStepId];

                if (ctrl.value.rgCtrls.adrPays == undefined || adrPaysCtrl.value === '' || adrPaysCtrl.value === null || adrPaysCtrl.value === undefined) {
                    if (((adrCpCtrl.value !== '' && adrCpCtrl.value !== null) ||
                        (adrVilleCtrl.value !== '' && adrVilleCtrl.value !== null) ||
                        (adrVoieNomvoieCtrl.value !== '' && adrVoieNomvoieCtrl.value !== null) ||
                        (adrVoieNumCtrl.value !== '' && adrVoieNumCtrl.value !== null) ||
                        (adrVoieTypevoieCtrl.value !== '' && adrVoieTypevoieCtrl.value !== null) ||
                        (codeIdentificationNationalCtrl.value !== '' && codeIdentificationNationalCtrl.value !== null) ||
                        (coordFaxCtrl.value !== '' && coordFaxCtrl.value !== null) ||
                        (coordMelCtrl.value !== '' && coordMelCtrl.value !== null) ||
                        (coordTelCtrl.value !== '' && coordTelCtrl.value !== null) ||
                        (coordUrlCtrl.value !== '' && coordUrlCtrl.value !== null)) && 
                        (personneMoraleCtrl.value === '' || personneMoraleCtrl.value === null)) {
                        // placer le message d'erreur
                        form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                    } else {
                        form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                    }
                } else {
                    if (((adrCp_eCtrl.value !== '' && adrCp_eCtrl.value !== null) ||
                        (adrVilleCtrl.value !== '' && adrVilleCtrl.value !== null) ||
                        (adrVoie_eNomvoieCtrl.value !== '' && adrVoie_eNomvoieCtrl.value !== null) ||
                        (adrVoie_eNumCtrl.value !== '' && adrVoie_eNumCtrl.value !== null) ||
                        (adrVoie_eTypevoieCtrl.value !== '' && adrVoie_eTypevoieCtrl.value !== null) ||
                        (codeIdentificationNationalCtrl.value !== '' && codeIdentificationNationalCtrl.value !== null) ||
                        (coordFaxCtrl.value !== '' && coordFaxCtrl.value !== null) ||
                        (coordMelCtrl.value !== '' && coordMelCtrl.value !== null) ||
                        (coordTelCtrl.value !== '' && coordTelCtrl.value !== null) ||
                        (coordUrlCtrl.value !== '' && coordUrlCtrl.value !== null)) && 
                        (personneMoraleCtrl.value === '' || personneMoraleCtrl.value === null)) {
                        // placer le message d'erreur
                        form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                    } else {
                        form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                    }
                }
            }
        }
    }
}